module.exports = __webpack_public_path__ + "img/alarm2.7513c5f3.svg";